<fieldset class="u-fade-slide-in">
  <h4>{{ 'content_type_block.header' | translate | upperFirstLetter }}</h4>
  <div>
    <h3>{{ 'content_type_block.title' | translate | upperFirstLetter }}</h3>
    <p>{{ 'content_type_block.subtitle' | translate | upperFirstLetter }}</p>
  </div>
  <app-input-radio-element
    [elementsList]="contentItemList"
    [selectedValue]="selectedContentType()"
    [disabled]="disabled()"
    (valueChange)="onContentTypeChange($event)"
  />
</fieldset>
